module.exports = __webpack_public_path__ + "1f73c31fc5c9cbe5874f24c5b870b1de.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-nestable/dist/Icon/icon-plus-gray.svg
// module id = 1562
// module chunks = 0